import axios from "axios";
import { buildQueryString, QueryParam } from "../queryUtils";
import { baseUrl } from "../apiUrl";
import { Exception, ExceptionCounts, Exceptions } from "./types";

// Get all Exceptions
export const getExceptions = async (query: QueryParam): Promise<Exceptions> => {
  try {
    const response = await axios.get<Exceptions>(`${baseUrl}/clo-hms/homesite/exceptions?${buildQueryString(query)}`);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch exceptions: ${error}`);
  }
};

// Aggregate Exceptions By Homesite ID and Milestone Name
export const getExceptionsCount = async (query: QueryParam): Promise<ExceptionCounts<Exception>> => {
  try {
    const response = await axios.get<ExceptionCounts<Exception>>(
      `${baseUrl}/clo-hms/homesite/exceptions?${buildQueryString(query)}`
    );
    return response.data;
  } catch (error) {
    throw new Error(`Failed to fetch exceptions: ${error}`);
  }
};

// Update a specific Exception by ID and Homesite ID
export const updateException = async (exception: Partial<Exception>): Promise<Exception> => {
  try {
    const response = await axios.patch<Exception>(`${baseUrl}/clo-hms/homesite/exceptions`, exception);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to update exception with ID ${exception.id}: ${error}`);
  }
};

export const createException = async (exception: Partial<Exception>): Promise<Exception> => {
  try {
    const response = await axios.post<Exception>(`${baseUrl}/clo-hms/homesite/exceptions`, exception);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to create exception: ${error}`);
  }
};
